var map = {
	"./black.svg": 113,
	"./blue.svg": 4812,
	"./colorless.svg": 9318,
	"./green.svg": 497,
	"./hybrid-2b.svg": 3267,
	"./hybrid-2g.svg": 7614,
	"./hybrid-2r.svg": 7939,
	"./hybrid-2u.svg": 284,
	"./hybrid-2w.svg": 382,
	"./hybrid-bg.svg": 5150,
	"./hybrid-br.svg": 8035,
	"./hybrid-gu.svg": 3703,
	"./hybrid-gw.svg": 7125,
	"./hybrid-rg.svg": 5294,
	"./hybrid-rw.svg": 9966,
	"./hybrid-ub.svg": 7550,
	"./hybrid-ur.svg": 2878,
	"./hybrid-wb.svg": 1416,
	"./hybrid-wu.svg": 5927,
	"./phyrexian-b.svg": 5075,
	"./phyrexian-c.svg": 1762,
	"./phyrexian-g.svg": 9422,
	"./phyrexian-r.svg": 2931,
	"./phyrexian-u.svg": 364,
	"./phyrexian-w.svg": 4750,
	"./red.svg": 101,
	"./snow.svg": 1433,
	"./white.svg": 5975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4034;